import axios from 'axios'

export default {
    getBaseUrl() {
        return axios.defaults.baseURL
    },
    login(username, password) {
        // TODO: change the base url, client id, and client secret to use a config

        var params = new URLSearchParams()
        params.append('grant_type', 'password')
        params.append('username', username)
        params.append('password', password)
        params.append('client_id', 'webclient')

        //instance(options).then(({ data }) => {
        return axios({
            method: 'POST',
            url: 'oauth/token',
            auth: {username: 'webclient', password: 'mMjeZD51vd6FPLY8Qcl3b0FpkIzr03MH'},
            headers: {
                'Access-Control-Allow-Origin': SELF_URL,
                "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
            },
            data: params
        })
    },
    cityAutoComplete(params) {
        return axios.get(`/v1/settings/cities`, {
            params: params
        })
    },
    getCustomers(query, mobileNumber, contractNumber, pagination) {
        return axios.get(`/v1/admin/customers`, {
            params: {
                email: query,
                mobileNumber: mobileNumber,
                contractNumber: contractNumber,
                page: pagination.page,
                size: pagination.pageSize
            }
        })
    },
    getPasswordResetLogs(query, pagination) {
        return axios.get(`/v1/admin/resetLogs`, {
            params: {
                email: query,
                page: pagination.page,
                size: pagination.pageSize
            }
        })
    },
    getCustomer(id) {
        return axios.get(`/v1/admin/customers/` + id)
    },
    getCustomerDevices(id, state, pagination) {
        return axios.get(`/v1/admin/customers/` + id + '/devices', {
            params: {
                state: state,
                page: pagination.page,
                size: pagination.pageSize
            }
        })
    },
    repossessCustomerDevice(customerId, ownershipId, comment) {
        return axios.post(`/v1/admin/customers/` + customerId + '/devices/' + ownershipId + '/repossess', {
            comment: comment
        })
    },
    updateDeviceContractNumber(customerId, ownershipId, contractNumber, comment) {
        return axios.post(`/v1/admin/customers/` + customerId + '/devices/' + ownershipId + '/updateContract', {
            contractNumber: contractNumber,
            comment: comment
        })
    },
    giveBackCustomerDevice(customerId, ownershipId, comment) {
        return axios.post('/v1/admin/customers/' + customerId + '/devices/' + ownershipId + '/give-back', {
            comment: comment
        })
    },
    resetCustomerDeviceParentModePassword(customerId, ownershipId) {
        return axios.post('/v1/admin/customers/' + customerId + '/devices/' + ownershipId + '/reset-password', {
            comment: null
        })
    },
    pairDevice(params) {
        return axios.post('/v1/admin/pair-device', params)
    },
    getAvailableDevices(query, mobileNumber, contractNumber, pagination) {
        return axios.get(`/v1/admin/available-devices`, {
            params: {
                email: query,
                mobileNumber: mobileNumber,
                contractNumber: contractNumber,
                page: pagination.page,
                size: pagination.pageSize
            }
        })
    },
    getDevice(id) {
        return axios.get(`/v1/admin/devices/` + id)
    },
    getDeviceLogs(id, pagination) {
        return axios.get(`/v1/admin/devices/` + id + '/logs', {
            params: {
                page: pagination.page,
                size: pagination.pageSize,
                sort: 'id,desc'
            }
        })
    },
    getDevicesOwners(id, pagination) {
        return axios.get(`/v1/admin/devices/` + id + '/owners', {
            params: {
                page: pagination.page,
                size: pagination.pageSize,
                sort: 'id,desc'
            }
        })
    },
    repairingDevice(id, comment) {
        return axios.post(`/v1/admin/devices/` + id + '/repairing', {
            comment: comment
        })
    },
    refurbishDevice(id, comment) {
        return axios.post(`/v1/admin/devices/` + id + '/refurbished', {
            comment: comment
        })
    },
    createUser(form) {
        return axios.post(`/v1/users`, form)
    },
    updateUser(form) {
        return axios.patch(`/v1/users/` + form.userId, form)
    },
    deleteUser(userId) {
        return axios.delete(`/v1/users/` + userId)
    },
    getProfile() {
        return axios.get('/v1/me')
    },
    getUsers(filter) {
        return axios.post(`/v1/users/list`, filter)
    },
    getUser(id) {
        return axios.get(`/v1/users/` + id)
    },
    getRoles(query, pagination, active = null) {
        return axios.get(`/v1/settings/roles`, {
            params: {
                name: query,
                page: pagination.page,
                size: pagination.pageSize,
                active: active
            }
        })
    },
    getRole(id) {
        return axios.get(`/v1/settings/roles/` + id)
    },
    createRole(form) {
        return axios.post(`/v1/settings/roles`, form)
    },
    updateRole(form) {
        return axios.patch(`/v1/settings/roles/` + form.roleId, form)
    },
    getWebForms(query, pagination) {
        return axios.get(`/v1/launcher/webForms`, {
            params: {
                page: pagination.page,
                size: pagination.pageSize,
                query: query
            }
        })
    },
    getWebForm(id) {
        return axios.get(`/v1/launcher/webForms/` + id)
    },
    getWebFormTemplate(id, templateId) {
        return axios.get(`/v1/launcher/webForms/` + id + '/templates/' + templateId)
    },
    updateWebForm(form) {
        return axios.patch(`/v1/launcher/webForms/` + form.webFormId, form)
    },
    createWebFormTemplate(form) {
        return axios.post(`/v1/launcher/webForms/` + form.webFormId + '/templates', form)
    },
    getWebFormTemplates(webFormId, pagination) {
        return axios.get(`/v1/launcher/webForms/` + webFormId + '/templates', {
            params: {
                page: pagination.page,
                size: pagination.pageSize,
                sort: 'versionId,desc'
            }
        })
    },
    getWebFormEntries(email, templateVersionId, webFormId, pagination) {
        return axios.get('/v1/launcher/webFormEntries', {
            params: {
                email: email,
                templateVersionId: templateVersionId,
                webFormId: webFormId,
                page: pagination.page,
                size: pagination.pageSize
            }
        })
    },
    getPolicies(query, pagination) {
        return axios.get(`/v1/launcher/activationPolicies`, {
            params: {
                page: pagination.page,
                size: pagination.pageSize,
                sort: pagination.sort,
                query: query
            }
        })
    },
    getPolicy(id) {
        return axios.get(`/v1/launcher/activationPolicies/` + id)
    },
    updateActivationPolicy(form) {
        return axios.patch(`/v1/launcher/activationPolicies/` + form.policyId, form)
    },
    getPolicyRecords(apId, pagination) {
        return axios.get(`/v1/launcher/activationPolicies/` + apId + '/records', {
            params: {
                page: pagination.page,
                size: pagination.pageSize,
                sort: 'policyId,desc'
            }
        })
    },
    getCountries(query, pagination, active = null) {
        let param = {
            name: query,
            page: pagination.page,
            size: pagination.pageSize,
            sort: pagination.sort,
            active: active
        };

        param[pagination.sort + '.dir'] = pagination.dir;
        return axios.get(`/v1/settings/officeCountries`, {
            params: param
        })
    },
    getCountry(code) {
        return axios.get(`/v1/settings/officeCountries/` + code)
    },
    createCountries(form) {
        return axios.post(`/v1/settings/officeCountries`, {
            name: form.country.country,
            code: form.country.abbreviation,
            description: form.description,
            active: form.active
        })
    },
    updateOfficeCountry(form) {
        return axios.patch(`/v1/settings/officeCountries/` + form.countryId, {
            description: form.description,
            active: form.active
        })
    },
    getSRCountries(query, pagination, active = null) {
        let param = {
            name: query,
            page: pagination.page,
            size: pagination.pageSize,
            sort: pagination.sort,
            active: active
        };

        param[pagination.sort + '.dir'] = pagination.dir;

        return axios.get(`/v1/settings/SRCountries`, {
            params: param
        })
    },
    createSRCountry(form) {
        return axios.post(`/v1/settings/SRCountries`, {
            name: form.country.country,
            code: form.country.abbreviation,
            description: form.description,
            active: form.active
        })
    },
    updateSRCountry(form) {
        return axios.patch(`/v1/settings/SRCountries/` + form.countryId, {
            description: form.description,
            active: form.active
        })
    },
    getCities(query, pagination, active = null) {
        let param = {
            name: query.name,
            countryId: query.countryId,
            page: pagination.page,
            size: pagination.pageSize,
            sort: pagination.sort,
            active: active
        };

        param[pagination.sort + '.dir'] = pagination.dir;

        return axios.get(`/v1/settings/officeCities`, {
            params: param
        })
    },
    createCities(form) {
        return axios.post(`/v1/settings/officeCities`, {
            name: form.name,
            countryCode: form.countryCode,
            description: form.description,
            active: form.active
        })
    },
    updateOfficeCity(form) {
        return axios.patch(`/v1/settings/officeCities/` + form.cityId, {
            description: form.description,
            active: form.active
        })
    },
    filterOffices(query, pagination, filter, active = null) {
        let param = {
            name: query,
            cityId: filter.cityId,
            countryId: filter.countryId,
            page: pagination.page,
            size: pagination.pageSize,
            sort: pagination.sort,
            active: active
        };
        param[pagination.sort + '.dir'] = pagination.dir;
        return axios.get(`/v1/settings/officeNames`, {
            params: param
        })
    },
    getOffices(query, pagination) {
        let param = {
            name: query,
            page: pagination.page,
            size: pagination.pageSize,
            sort: pagination.sort,
            active: true
        };
        param[pagination.sort + '.dir'] = pagination.dir;
        return axios.get(`/v1/settings/officeNames`, {
            params: param
        })
    },
    getOffice(id) {
        return axios.get(`/v1/settings/officeNames/` + id)
    },
    createOffice(form) {
        return axios.post(`/v1/settings/officeNames`, form)
    },
    updateOffice(form) {
        return axios.patch(`/v1/settings/officeNames/` + form.officeId, form)
    },
    getDepartments(query, pagination, active = null) {
        let param = {
            name: query,
            page: pagination.page,
            size: pagination.pageSize,
            sort: pagination.sort,
            active: active
        };
        param[pagination.sort + '.dir'] = pagination.dir;

        return axios.get(`/v1/settings/departments`, {
            params: param
        })
    },
    createDepartments(form) {
        return axios.post(`/v1/settings/departments`, {
            name: form.name,
            description: form.description,
            active: form.active
        })
    },
    updateDepartment(form) {
        return axios.patch(`/v1/settings/departments/` + form.departmentId, {
            name: form.name,
            description: form.description,
            active: form.active
        })
    },
    getPreferences() {
        return axios.get(`/v1/settings/preferences`)
    },
    sendTestEmail(form) {
        return axios.post(`/v1/settings/preferences/test-email`, form)
    },
    savePreferences(form) {
        return axios.post(`/v1/settings/preferences`, form)
    },
    resetUserPassword(form) {
        return axios.post(`/v1/me/reset-password`, form)
    },
}
